import { Col, Container, Row } from "react-bootstrap";
import DataTable from "../../../../common/DataTable";
import { USER_MAPPING_LIST_HEADERS } from "../action/constant";
import AddUpdateUserMapping from "./AddUpdateUserMapping";
import { useEffect, useRef, useState } from "react";
import { getUserMappingSearch } from "../../../../services/TeamsUserMapping";
import Loader from "../../../../common/Loader";
import SearchInput from "../../../../common/InlineSearch";

const UserMappingDashboard: React.FC<any> = ({
  teamId,
  onClose,
  showAddUpdateUserMapping,
  setShowAddUpdateUserMapping,
}) => {
  const [selectedUserData, setSelectedUserData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState<any[]>([]);
  const searchInputRef = useRef<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const fetchUserMappingSearchData = async (searchText?: string) => {
    const params = {
      teamId: teamId,
      searchText: searchText || "",
    };
    try {
      setLoading(true);
      const searchList = await getUserMappingSearch(params);
      setListData(searchList || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      fetchUserMappingSearchData(searchQuery);
    }, 300);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery]);

  const handleSearchQueryChange = (query: string) => {
    setSearchQuery(query);
  };

  const handleReset = () => {
    searchInputRef.current?.clear();
    setSearchQuery("");
  };

  const handleRowAction = (row: any, action: string) => {
    setShowAddUpdateUserMapping(true);
    setSelectedUserData(row);
  };

  const handleCloseAction = () => {
    setSelectedUserData(null);
    fetchUserMappingSearchData("");
    onClose();
  };

  return (
    <>
      <Loader isLoading={loading} />
      {!showAddUpdateUserMapping ? (
        <div className="main_wrapper_section">
          <Container fluid className="px-5 container-fluid py-2">
            <Row className="mt-3 align-items-center px-2 py-1 ">
              <Col className="d-flex justify-content-between align-items-center border-bottom pb-2 px-0 cancelappointment">
                <h3 className="mr-2 me-auto">List</h3>
                <div
                  className="d-flex  py-2 search_closer align-items-center position-absolute justify-content-end"
                  style={{ marginTop: "-15px", right: "57px", width: "30%" }}
                >
                  <div style={{ width: "85%" }} className="gridsearch">
                    <SearchInput
                      ref={searchInputRef}
                      data={listData}
                      searchKeys={[]}
                      onSearchResult={() => {}}
                      placeholder="Search"
                      onSearchQueryChange={handleSearchQueryChange}
                    />
                  </div>
                  <button
                    onClick={handleReset}
                    className="reset_btn"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      marginTop: "3px",
                    }}
                  >
                    <span className="material-icons reset_ic0">
                      restart_alt
                    </span>
                  </button>
                </div>
              </Col>
            </Row>
            <Row className="px-0 py-1">
              <DataTable
                headers={USER_MAPPING_LIST_HEADERS}
                rows={listData}
                onAction={handleRowAction}
                isUserMappingTable={true}
              />
            </Row>
          </Container>
        </div>
      ) : (
        <AddUpdateUserMapping
          teamId={teamId}
          userData={selectedUserData}
          onClose={handleCloseAction}
        />
      )}
    </>
  );
};

export default UserMappingDashboard;
